export default __webpack_public_path__ + "static/media/greenspot.4610b38b.png";